import React, { useState } from "react";
import { BorderedButton } from "../../../commonComponents";
import { useCountdown } from "../../../../helpers/timer.js";
import JoinGameModal from "../../../modals/JoinGameModal/JoinGameModal";
import ChampionsChoiceLogo from "../../../../assets/images/auths/logo.svg";
import { getLeagueImage } from "../../../../helpers/leagueLogo";
import "./JoinGame.scss";
import { ReactComponent as DollarIcon } from  "../../../../assets/images/dollar.svg";

const JoinGame = ({ gameDetails }) => {
  const [days, hours, minutes] = useCountdown(gameDetails.start_date);
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);

  const openContactUsModal = () => {
    setIsContactUsModalOpen(true);
  };
  const closeContactUsModal = () => {
    setIsContactUsModalOpen(false);
  };

  return (
    <div className="join-game black-background">
      <JoinGameModal
        visible={isContactUsModalOpen}
        closeModal={closeContactUsModal}
        gameDetails={gameDetails}
      />
      <div className="join-game-image">
        <div className="join-game-image-banner">
          <img
            src={ChampionsChoiceLogo}
            alt="Champion's Choice"
            className="join-game-image-banner-logo"
          />
        </div>
      </div>
      <div className="join-game-cont">
        <div className="join-game-cont-top">
          <div className="join-game-cont-top-title">
            <div className="join-game-cont-top-title-icon">
              <img
                src={getLeagueImage(gameDetails.league_name, gameDetails.league_image)}
                alt="title-icon"
                className="image-cover-full"
                style={{ width: gameDetails?.sport_id == 2 ? "17px" : "24px" }}
              />
            </div>
            <span className="join-game-cont-top-title-text font-cairo-medium">
              {gameDetails.league_name}
            </span>
          </div>
          <div className="join-game-timer">
            <div className="d-grid">
              <span className="join-game-timer-cont font-cairo-medium">
                {days}
              </span>
              <span className="join-game-timer-text font-cairo-normal">
                Days
              </span>
            </div>
            <div className="d-grid">
              <span className="join-game-timer-cont font-cairo-medium">
                {hours}
              </span>
              <span className="join-game-timer-text font-cairo-normal">
                Hours
              </span>
            </div>
            <div className="d-grid">
              <span className="join-game-timer-cont font-cairo-medium">
                {minutes}
              </span>
              <span className="join-game-timer-text font-cairo-normal">
                Minutes
              </span>
            </div>
          </div>
        </div>
        <div className="join-game-cont-bottom">
          <div className="join-game-cont-bottom-left font-cairo-normal">
            Stake:
            {gameDetails.stake == "0.0" ? (
              <span className="font-cairo-bold left-gap">Free*</span>
            ) : (
              <>
                <div className="join-game-cont-bottom-left-icon">
                  <DollarIcon />
                </div>
                <span className="font-cairo-bold left-side">
                  {Math.floor(gameDetails.stake).toLocaleString('en-US')}
                </span>
              </>
            )}
          </div>
          <div className="join-game-cont-bottom-right font-cairo-normal">
            Pot:
            <div className="join-game-cont-bottom-right-icon">
            <DollarIcon/>
            </div>
            <span className="font-cairo-bold left-side">
              {Math.floor(gameDetails.pot).toLocaleString('en-US')}
            </span>
          </div>
        </div>
      </div>
      <div className="join-game-button">
        <BorderedButton
          name={gameDetails.is_joined ? "Game Joined" : "Join Game"}
          link={"#"}
          btnClass="join-game-button-class"
          functionCall={gameDetails.is_joined ? null : openContactUsModal}
        />
      </div>
    </div>
  );
};

export default JoinGame;
